import { URL } from './endpoints'
import { submitToApi } from 'awsApi'

export const ACTIONS = {
    GET_TRANSACTIONS: {
        START: 'GET_TRANSACTIONS START',
        SUCCESS: 'GET_TRANSACTIONS SUCCESS',
        FAILURE: 'GET_TRANSACTIONS FAILURE',
    },
    POST_TRANSACTION: {
        START: 'POST_TRANSACTION START',
        SUCCESS: 'POST_TRANSACTION SUCCESS',
        FAILURE: 'POST_TRANSACTION FAILURE',
    },
    CLEAN_TRANSACTION: 'CLEAN_TRANSACTION',
    TRANSACTION_UPDATE: 'TRANSACTION_UPDATE',
    TRANSACTION_UPDATE_PAYMENTMETHODID: 'TRANSACTION_UPDATE_PAYMENTMETHODID',
    STORE_TRANSACTION_TO_REDUX: 'STORE_TRANSACTION_TO_REDUX',
    CANCEL_TRANSACTION: {
        START: 'CANCEL_TRANSACTION START',
        SUCCESS: 'CANCEL_TRANSACTION SUCCESS',
        FAILURE: 'CANCEL_TRANSACTION FAILURE',
    },
    STORE_HELP_TRANSACTION: 'STORE_HELP_TRANSACTION',
    UPDATE_HELP_ANSWER: 'UPDATE_HELP_ANSWER',
    UPDATE_HELP_ERROR: 'UPDATE_HELP_ERROR',
    CLEAN_TRANSACTION_HELP: 'CLEAN_TRANSACTION_HELP',
    POST_TRANSACTION_HELP: {
        START: 'POST_TRANSACTION_HELP START',
        SUCCESS: 'POST_TRANSACTION_HELP SUCCESS',
        FAILURE: 'POST_TRANSACTION_HELP FAILURE',
    },
    STORE_CARD_ELEMENT_TO_REDUX: 'STORE_CARD_ELEMENT_TO_REDUX',
    REMOVE_CARD_ELEMENT_FROM_REDUX: 'REMOVE_CARD_ELEMENT_FROM_REDUX',
    SET_SELECTED_AUTOMATION_TYPE: 'SET_SELECTED_AUTOMATION_TYPE',
}

export const getTransactions =
    (successCallback = () => {}) =>
    async dispatch => {
        dispatch({ type: ACTIONS.GET_TRANSACTIONS.START })
        try {
            const { payload } = await submitToApi({
                path: URL.TRANSACTIONS.V3_TRANSACTIONS_USER_RETRIEVE,
                url: URL.TRANSACTIONS.BASE,
            })
            dispatch({ type: ACTIONS.GET_TRANSACTIONS.SUCCESS, data: payload.data })
            successCallback(payload.data.length)
        } catch (error) {
            dispatch({ type: ACTIONS.GET_TRANSACTIONS.FAILURE, error })
        }
    }

export const postTransaction =
    (body, callback = () => {}) =>
    async dispatch => {
        dispatch({ type: ACTIONS.POST_TRANSACTION.START })
        try {
            const { message, payload } = await submitToApi({
                body,
                method: 'POST',
                path: URL.TRANSACTIONS.V3_TRANSACTIONS_USER_CREATE,
                url: URL.TRANSACTIONS.BASE,
            })
            dispatch({ type: ACTIONS.POST_TRANSACTION.SUCCESS, data: payload.data })
            callback(message, 'success')
        } catch (error) {
            dispatch({ type: ACTIONS.POST_TRANSACTION.FAILURE, error })
            callback(error, 'error')
        }
    }

export const storeTransactionToRedux = transaction => dispatch => dispatch({ type: ACTIONS.STORE_TRANSACTION_TO_REDUX, transaction })

export const cleanTransaction = () => dispatch => dispatch({ type: ACTIONS.CLEAN_TRANSACTION })

export const transactionPostUpdate = transaction => async dispatch => {
    dispatch({ type: ACTIONS.POST_TRANSACTION.START })
    try {
        const { message, payload } = await submitToApi({
            body: transaction,
            method: 'POST',
            path: URL.TRANSACTIONS.V3_TRANSACTIONS_USER_UPDATE,
            url: URL.TRANSACTIONS.BASE,
        })
        dispatch({ type: ACTIONS.TRANSACTION_UPDATE, data: payload.data })
    } catch (error) {
        dispatch({ type: ACTIONS.POST_TRANSACTION.FAILURE, error })
    }
}

export const transactionUpdatePaymentMethodId = paymentMethodId => dispatch =>
    dispatch({ type: ACTIONS.TRANSACTION_UPDATE_PAYMENTMETHODID, paymentMethodId })

export const cancelTransaction =
    (body, callback = () => {}) =>
    async dispatch => {
        dispatch({ type: ACTIONS.CANCEL_TRANSACTION.START })
        try {
            const { message, payload } = await submitToApi({
                body,
                method: 'POST',
                path: URL.TRANSACTIONS.V3_TRANSACTIONS_USER_CANCEL,
                url: URL.TRANSACTIONS.BASE,
            })
            dispatch({ type: ACTIONS.CANCEL_TRANSACTION.SUCCESS, data: payload.data })
            callback(message, 'success')
        } catch (error) {
            dispatch({ type: ACTIONS.CANCEL_TRANSACTION.FAILURE, error })
            callback(error, 'error')
        }
    }

export const storeHelpTransaction =
    (trans, successCallback = () => {}) =>
    dispatch => {
        dispatch({ type: ACTIONS.STORE_HELP_TRANSACTION, data: trans })
        successCallback()
    }

export const updateHelpAnswer =
    (data, successCallback = () => {}) =>
    dispatch => {
        dispatch({ type: ACTIONS.UPDATE_HELP_ANSWER, data })
        successCallback()
    }

export const updateHelpError =
    (data, successCallback = () => {}) =>
    dispatch => {
        dispatch({ type: ACTIONS.UPDATE_HELP_ERROR, data })
        successCallback()
    }

export const cleanTransactionHelp =
    (successCallback = () => {}) =>
    dispatch => {
        dispatch({ type: ACTIONS.CLEAN_TRANSACTION_HELP })
        successCallback()
    }

export const postTransactionHelp =
    (body, from, callback = () => {}) =>
    async dispatch => {
        dispatch({ type: ACTIONS.POST_TRANSACTION_HELP.START })
        try {
            const { message } = await submitToApi({
                body,
                method: 'POST',
                path: URL.EMAIL_SUPPORT.V2_EMAILSUPPORT_USER_OPENTICKET,
                query: { from },
                url: URL.EMAIL_SUPPORT.BASE,
            })
            dispatch({ type: ACTIONS.POST_TRANSACTION_HELP.SUCCESS })
            callback(message, 'success')
        } catch (error) {
            dispatch({ type: ACTIONS.POST_TRANSACTION_HELP.FAILURE })
            callback(error, 'error')
        }
    }

export const storeCardElementToRedux = card => dispatch => dispatch({ type: ACTIONS.STORE_CARD_ELEMENT_TO_REDUX, card })
export const removeCardElementFromRedux = () => dispatch => dispatch({ type: ACTIONS.REMOVE_CARD_ELEMENT_FROM_REDUX })

export const setSelectedAutomationType = automationType => dispatch => dispatch({ type: ACTIONS.SET_SELECTED_AUTOMATION_TYPE, automationType })
